import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: "art-item-open-in-new-button",
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule],
  template: `
    <a
      class="hover:text-green-500"
      [href]="'/item/' + itemId"
      target="_blank"
      mat-icon-button
      matTooltip="Otevřít detail díla na nové kartě"
    >
      <mat-icon svgIcon="mat:open_in_new"></mat-icon>
    </a>
  `,
})
export class ItemOpenInNewButtonComponent {
  @Input() itemId: string;
}
